/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free typing speed test. Measure your words per minute (WPM) and accuracy in a 60-second test — or try 1, 3, and 5-minute modes. No signup.`)
};

const es_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de mecanografía gratis. Mide tu WPM y precisión en 60 segundos, o prueba los modos de 1, 3 y 5 minutos. Sin registro.`)
};

const de_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Tipptest: Miss deine Wörter pro Minute (WPM) und Genauigkeit in 60 Sekunden — oder probiere die 1-, 3- und 5-Minuten-Modi. Keine Anmeldung.`)
};

const nl_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis typsnelheidstest. Meet je woorden per minuut (WPM) en nauwkeurigheid in 60 seconden, of kies de modus van 1, 3 of 5 minuten. Geen aanmelding nodig.`)
};

const fr_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test de vitesse de frappe gratuit. Mesurez vos mots par minute (WPM) et votre précision en 60 secondes — ou essayez les modes 1, 3 et 5 minutes. Sans inscription.`)
};

const it_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Test di digitazione gratuito. Misura WPM e precisione in un test di 60 secondi, o prova le modalità da 1, 3 e 5 minuti. Nessuna registrazione.`)
};

const pt_br2_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de velocidade de digitação grátis. Meça suas palavras por minuto (WPM) e precisão em um teste de 60 segundos — ou experimente os modos de 1, 3 e 5 minutos. Sem cadastro.`)
};

const pt_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teste de velocidade de escrita gratuito. Meça o seu WPM e precisão num teste de 60 segundos, ou experimente os modos de 1, 3 e 5 minutos. Sem registo.`)
};

const ja_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のタイピングスピードテスト。60秒テストで1分間の入力文字数（WPM）と正確率を測定 — 1分・3分・5分モードも利用可能。登録不要。`)
};

const zh_typing_hub_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费打字速度测试。通过60秒测试测量您的每分钟字数（WPM）和准确率 — 或尝试1、3、5分钟模式。无需注册。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const typing_hub_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.typing_hub_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("typing_hub_meta_description", locale)
	if (locale === "en") return en_typing_hub_meta_description(inputs)
	if (locale === "es") return es_typing_hub_meta_description(inputs)
	if (locale === "de") return de_typing_hub_meta_description(inputs)
	if (locale === "nl") return nl_typing_hub_meta_description(inputs)
	if (locale === "fr") return fr_typing_hub_meta_description(inputs)
	if (locale === "it") return it_typing_hub_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_typing_hub_meta_description(inputs)
	if (locale === "pt") return pt_typing_hub_meta_description(inputs)
	if (locale === "ja") return ja_typing_hub_meta_description(inputs)
	return zh_typing_hub_meta_description(inputs)
};